<template>
  <div class="text-center">
    <v-dialog v-model="modalDelete" width="500">
      <v-card>

        <v-card-title class="text-h5 lighten-2">
          {{$t('confirmDelete')}}
        </v-card-title>

        <v-card-text>
          {{$t('areYouSureDelete')}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="confirm(false)">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="error" text @click="confirm(true)">
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ModalDelete",
  props: ['modalDelete'],
  methods:{
    confirm(mode){
      this.$emit('message',mode)
    }
  }
}
</script>

<style scoped>

</style>